export default __webpack_public_path__ + "static/media/fred.c7562247.jpeg";